import {gql} from "@apollo/client";

export default gql`
  mutation ratingWorker($data: BatchWorkerRatingInput!) {
    ratingWorker(data: $data)
  }
`;
